import { Input } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import { TMarketingForm } from './MarketingPoll';
import styles from './PollOptionDetail.module.css';
import { useLocale } from '../../hooks/useLocale';
import { Button } from '../Button/Button';

const PollOptionDetail = () => {
  const { register, watch } = useFormContext<TMarketingForm>();
  const { t } = useLingui();
  const { isUK } = useLocale();

  return (
    <section className={styles.detailedAnswerContainer}>
      <div className={styles.detailedAnswerForm}>
        <Input
          {...register('detail')}
          wrapperClassName={styles.detailedAnswerWrapper}
          label={t`Where else did you hear about us?`}
          placeholder={isUK ? 'e.g. Expo' : undefined}
        />
        <Button
          type="submit"
          variant="primary"
          className={styles.detailedCTA}
          disabled={!watch('detail')}
        >
          <Trans>Submit answer</Trans>
        </Button>
      </div>
    </section>
  );
};

export default PollOptionDetail;
